import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useEffect } from 'react';

// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import sostenibilidad from './img/sostenibilidad.png'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

import fullcolor from './img/productos/fullcolor.png'
import coopermix from './img/productos/coopermix.png'
import powermix from './img/productos/powermix.png'
import termomuro from './img/productos/termomuro.png'
import wallmix from './img/productos/wallmix.png'
import freezermix from './img/productos/freezermix.png'

import imagina from './img/imagina-fc.png'

import Velocity from 'velocity-animate';

function App() {

  useEffect(() => {

    let blocks = document.querySelectorAll('.product-block');

    for (let i=0; i<blocks.length;i++) {
      Velocity.animate(blocks[i], { opacity: 1 }, { duration: 250, delay: i*100 });
    }

  }, [])

  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={sostenibilidad} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-1">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white t-54 pb-3 title-shade">Cuidado del Medio Ambiente</h3>    
                  </div>

                  <div className="col-11 d-flex flex-row align-items-center pt-3">

                    <div className="row d-flex flex-1">

                      <div className="col-4">
                        <Link to="/sostenibilidad/carbono" relative="path">
                          <div className="product-block product-block-grow d-flex flex-column">
                            <div className="product-block-upper flex-1">
                              <p className="product-block-bottom-text text-center">Carbono Neutralidad <span className="chevron">></span></p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-4">
                        <Link to="/sostenibilidad/economia" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Economía Circular <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col-4">
                        <Link to="/sostenibilidad/energia" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Energía Limpia <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                    </div>                    

                  </div>
                </div>
                
              </div>

              <div className="col d-flex flex-column">

                <div className="row">

                  <div className="col-11 d-flex flex-row">

                    <div className="row d-flex flex-1">

                      <div className="col-4 offset-2">
                        <Link to="/sostenibilidad/eficiencia" relative="path">
                          <div className="product-block product-block-grow d-flex flex-column">
                            <div className="product-block-upper flex-1">
                              <p className="product-block-bottom-text text-center">Eficiencia Hídrica <span className="chevron">></span></p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-4">
                        <Link to="/sostenibilidad/biodiversidad" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Biodiversidad <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                    </div>

                  </div>

                </div>





              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;